import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import LayoutHeader from "../../layout/LayoutHeader";

const LoginCatalog = () => {
    const [step, setStep] = useState(0); // 0: main categories, 1: subcategory selection, 2: login, 3: edit
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedService, setSelectedService] = useState('');
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [editData, setEditData] = useState({ songTitle: '', artist: '', releaseDate: '' });
    const [loggedInServices, setLoggedInServices] = useState({});
    const navigate = useNavigate();

    // Load logged in services from localStorage on component mount
    useEffect(() => {
        const savedLogins = localStorage.getItem('catalogLoggedInServices');
        if (savedLogins) {
            setLoggedInServices(JSON.parse(savedLogins));
        }
    }, []);

    const mainCategories = [
        {
            name: 'Label/Distributors', 
            description: 'Connect to major record labels and distributors',
            icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h2M7 16h6M7 8h6'
        },
        {
            name: 'Publishers', 
            description: 'Access major music publishing companies',
            icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
        },
        {
            name: 'PROs', 
            description: 'Performance Rights Organizations (ASCAP, BMI, SEASAC, SOCAN)',
            icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
        },
        { 
            name: 'Sound Exchange', 
            description: 'Digital performance royalty collection service',
            icon: 'M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z'
        }
    ];

    const servicesByCategory = {
        'Label/Distributors': [
            'Universal Music Group',
            'Sony Music Entertainment',
            'Warner Music Group',
            'BMG Rights Management',
            'Atlantic Records',
            'Columbia Records',
            'Interscope Records',
            'Capitol Records',
            'RCA Records',
            'Def Jam Recordings'
        ],
        'Publishers': [
            'Universal Music Publishing Group',
            'Sony Music Publishing',
            'Warner Chappell Music',
            'BMG Rights Management',
            'Kobalt Music Publishing',
            'Concord Music Publishing',
            'peermusic',
            'Downtown Music Publishing',
            'Spirit Music Group',
            'Primary Wave Music'
        ],
        'PROs': [
            'ASCAP',
            'BMI',
            'SEASAC',
            'SOCAN'
        ],
        'Sound Exchange': [
            'SoundExchange'
        ]
    };

    const handleCategorySelect = (categoryName) => {
        setSelectedCategory(categoryName);
        if (categoryName === 'Sound Exchange') {
            // Skip subcategory selection for Sound Exchange
            setSelectedService('SoundExchange');
            setStep(2);
        } else {
            setStep(1);
        }
    };

    const handleServiceSelect = (serviceName) => {
        setSelectedService(serviceName);
        setStep(2);
    };

    const handleLogin = () => {
        if (loginData.email && loginData.password) {
            // Save login status
            const newLoggedInServices = {
                ...loggedInServices,
                [selectedService]: {
                    email: loginData.email,
                    category: selectedCategory,
                    loginTime: new Date().toISOString()
                }
            };
            setLoggedInServices(newLoggedInServices);
            localStorage.setItem('catalogLoggedInServices', JSON.stringify(newLoggedInServices));
            
            setStep(3);
        } else {
            alert('Please enter both email and password');
        }
    };

    const handleSave = () => {
        if (editData.songTitle && editData.artist && editData.releaseDate) {
            alert('Catalog item saved successfully!');
            navigate('/catalog/view-all');
        } else {
            alert('Please fill in all fields');
        }
    };

    const handleBackToCategories = () => {
        setStep(0);
        setSelectedCategory('');
        setSelectedService('');
        setLoginData({ email: '', password: '' });
        setEditData({ songTitle: '', artist: '', releaseDate: '' });
    };

    const getLoggedInCount = () => {
        return Object.keys(loggedInServices).length;
    };

    return (
        <LayoutHeader>
            <div className="flex justify-center w-full">
                <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
                    {/* Header */}
                    <div className="px-4 my-[50px] flex w-full justify-between items-center">
                        <p className="text-white text-[12px]">Login with Label / Distro</p>
                        <div className="flex items-center gap-4">
                            {/* Navigation Buttons */}
                            <span 
                                className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                onClick={() => navigate('/catalog/view-all')}
                            >
                                View
                            </span>
                            
                            <span 
                                className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                onClick={() => navigate('/catalog/manual-add')}
                            >
                                Manual Add
                            </span>
                            
                        <span className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" onClick={() => navigate(-1)}>Go back</span>
                        </div>
                    </div>

                    <div className="w-full px-4 flex-1 overflow-y-auto">
                        {step === 0 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Choose service category</span>
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">
                                        Select a service category to connect your accounts
                                        {getLoggedInCount() > 0 && ` • ${getLoggedInCount()} service${getLoggedInCount() > 1 ? 's' : ''} connected`}
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    {mainCategories.map((category, index) => {
                                        const isLoggedIn = category.name === 'Sound Exchange' 
                                            ? loggedInServices['SoundExchange']
                                            : Object.keys(loggedInServices).some(service => 
                                                loggedInServices[service].category === category.name
                                            );
                                        
                                        return (
                                            <div 
                                                key={index}
                                                className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all cursor-pointer"
                                                onClick={() => handleCategorySelect(category.name)}
                                            >
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center gap-4">
                                                        <div className="w-12 h-12 bg-[rgba(23,162,184,0.2)] rounded-lg flex items-center justify-center">
                                                            <svg className="w-6 h-6 text-[#17A2B8]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={category.icon} />
                                                            </svg>
                                                        </div>
                                                        <div>
                                                            <div className="flex items-center gap-2">
                                                                <h3 className="text-white text-[12px] font-semibold">
                                                                    {category.name}
                                                                </h3>
                                                                {isLoggedIn && (
                                                                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                                                )}
                                                            </div>
                                                            <p className="text-[rgba(255,255,255,0.7)] text-[10px] mt-1">
                                                                {category.description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-3 h-3 rounded-full border-2 border-[#17A2B8]" />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {step === 1 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Select {selectedCategory}</span>
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Choose from the major {selectedCategory.toLowerCase()} to connect with</p>
                                </div>

                                <div className="space-y-3">
                                    {servicesByCategory[selectedCategory]?.map((service, index) => {
                                        const isLoggedIn = loggedInServices[service];
                                        
                                        return (
                                            <div 
                                                key={index}
                                                className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-3 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all cursor-pointer"
                                                onClick={() => handleServiceSelect(service)}
                                            >
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center gap-2">
                                                        <h3 className="text-white text-[12px] font-medium">
                                                            {service}
                                                        </h3>
                                                        {isLoggedIn && (
                                                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                                        )}
                                                    </div>
                                                    <div className="w-2 h-2 rounded-full border border-[#17A2B8]" />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="mt-6">
                                    <button
                                        onClick={handleBackToCategories}
                                        className="text-[#17A2B8] text-[12px] hover:opacity-70"
                                    >
                                        ← Back to categories
                                    </button>
                                </div>
                            </div>
                        )}

                        {step === 2 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Log in to {selectedService}</span>
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Enter your {selectedService} credentials to access your catalog</p>
                                </div>

                                <div className="space-y-4 mb-6">
                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Email Address
                                        </label>
                                        <input
                                            type="email"
                                            value={loginData.email}
                                            onChange={(e) => setLoginData({
                                                ...loginData,
                                                email: e.target.value
                                            })}
                                            placeholder="Enter your email"
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                                    </div>

                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Password
                                        </label>
                                        <input
                                            type="password"
                                            value={loginData.password}
                                            onChange={(e) => setLoginData({
                                                ...loginData,
                                                password: e.target.value
                                            })}
                                            placeholder="Enter your password"
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                                    </div>
                                </div>

                                <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all mb-4">
                                    <button
                                        onClick={handleLogin}
                                        className="w-full bg-[#17A2B8] text-white text-[12px] font-semibold py-3 rounded-lg hover:bg-[rgba(23,162,184,0.9)] transition-all"
                                    >
                                        Log In to {selectedService}
                                    </button>
                                </div>

                                <div>
                                    <button
                                        onClick={handleBackToCategories}
                                        className="text-[#17A2B8] text-[12px] hover:opacity-70"
                                    >
                                        ← Back to categories
                                    </button>
                                </div>
                            </div>
                        )}

                        {step === 3 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Edit Catalog Items</span>
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Update your catalog information from {selectedService}</p>
                                </div>

                                <div className="space-y-4 mb-6">
                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Song Title
                                        </label>
                                        <input
                                            type="text"
                                            value={editData.songTitle}
                                            onChange={(e) => setEditData({
                                                ...editData,
                                                songTitle: e.target.value
                                            })}
                                            placeholder="Enter song title"
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                                    </div>

                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Artist
                                        </label>
                                        <input
                                            type="text"
                                            value={editData.artist}
                                            onChange={(e) => setEditData({
                                                ...editData,
                                                artist: e.target.value
                                            })}
                                            placeholder="Enter artist name"
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                                    </div>

                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Release Date
                                        </label>
                                        <input
                                            type="date"
                                            value={editData.releaseDate}
                                            onChange={(e) => setEditData({
                                                ...editData,
                                                releaseDate: e.target.value
                                            })}
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                                    </div>
                                </div>

                                <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#17A2B8] hover:bg-[rgba(23,162,184,0.05)] transition-all mb-4">
                                    <button
                                        onClick={handleSave}
                                        className="w-full bg-[#17A2B8] text-white text-[12px] font-semibold py-3 rounded-lg hover:bg-[rgba(23,162,184,0.9)] transition-all"
                                    >
                                        Save Catalog Item
                                    </button>
                                </div>

                                <div>
                                    <button
                                        onClick={handleBackToCategories}
                                        className="text-[#17A2B8] text-[12px] hover:opacity-70"
                                    >
                                        ← Back to categories
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Help Text */}
                        <div className="mt-6 mb-4">
                            <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                                {step === 0 && (
                                    <>
                                        <p>Connect to multiple music services to import your catalog data.</p>
                                        <p>You can log in to services from different categories and stay connected.</p>
                                    </>
                                )}
                                {step === 1 && (
                                    <>
                                        <p>These are the major {selectedCategory.toLowerCase()} in the industry.</p>
                                        <p>Select the one you have an account with to connect.</p>
                                    </>
                                )}
                                {step === 2 && (
                                    <>
                                        <p>Use your existing {selectedService} account credentials.</p>
                                        <p>Your login information is encrypted and secure.</p>
                                    </>
                                )}
                                {step === 3 && (
                                    <>
                                        <p>Review and edit catalog information imported from {selectedService}.</p>
                                        <p>You can modify these details before saving to your account.</p>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutHeader>
    );
};

export default LoginCatalog;